import { UserRole } from '../enum/enum';

/**
 * User utility functions
 */

/**
 * Check if user has admin role
 */
export const isAdmin = (user: any): boolean => {
  if (!user?.role) return false;
  return user.role === UserRole.ADMIN || user.role === UserRole.SUPER_ADMIN;
};

/**
 * Check if user has dealer role
 */
export const isDealer = (user: any): boolean => {
  return user?.role === UserRole.DEALER;
};

/**
 * Get user role display name
 */
export const getUserRoleDisplay = (role: string): string => {
  const roleMap: Record<string, string> = {
    [UserRole.ADMIN]: 'Admin',
    [UserRole.SUPER_ADMIN]: 'Super Admin',
    [UserRole.DEALER]: 'Dealer',
    [UserRole.USER]: 'User',
  };
  return roleMap[role] || role;
};

/**
 * Get redirect path based on user role
 */
export const getRoleRedirectPath = (role: string | undefined): string => {
  if (!role) return '/';

  if (role === UserRole.ADMIN || role === UserRole.SUPER_ADMIN) {
    return '/admin';
  }

  return '/';
};
